export default __webpack_public_path__ + "static/media/EvChargeingInParking.6a0eb27c.png";